import { useMutation } from '@tanstack/react-query';

import type { OperationReverseMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useReverseOperationMutation = () =>
  useMutation({
    mutationFn: ({
      url,
      originalTransactionId,
    }: {
      url: string;
      originalTransactionId: number;
    }) =>
      HttpClient.request<OperationReverseMutationResponse>({
        method: 'POST',
        url,
        data: { reversal: { original_transaction_id: originalTransactionId } },
      }),
  });
